module.exports = __webpack_public_path__ + "img/beian.b769e8df.png";